import useTimeout from './useTimeout';

export default useTimeout;
